import toast from "react-hot-toast"
import { ConvertEnglish } from "../../components/ConterEnglsih"


export const areaApi = (bodyInfo,) =>{
    
    fetch(`https://amar-dish-server.vercel.app/areas`,{
        method:"POST",
        headers :{
            "content-type" : "application/json"
        },
        body : JSON.stringify(bodyInfo)
    })
    .then(res => res.json())
     .then(areaData => {
        if(areaData.acknowledged){
            // console.log(areaData)
        
            toast.success(<ConvertEnglish english={"Area added successfully"} bangla={"এরিয়া সংযোগ হয়েছে"} />)
        }
    })
}
